import { scrollTo } from '../../../benetech/js/utilities';

($ => {

	const $anchorNav = $('.fullWidthHero-anchorNavItems');

	if( $anchorNav ) {
		$('.fullWidthHero-anchorNavItem').off( 'click' );
		$('.fullWidthHero-anchorNavItem').click( event => {
			event.preventDefault();

			const $targetElement = $( $( event.currentTarget ).attr( 'href' ) );
			const $alert = $('header.alert');

			let offset = $anchorNav.outerHeight() * -1;

			if( $alert.length ) {
				offset = offset - $alert.outerHeight();
			}

			scrollTo( $targetElement, 500, { offset });
		});
	}

})(jQuery);



// WEBPACK FOOTER //
// ./js/templates/full-width-hero.js